<article>
  <h3 *ngIf="data.header" class="d-flex align-items-center">
    <span>{{ data.header }}</span>
  </h3>

  <mat-dialog-content>
    <div *ngIf="data.saveMessage">{{ data.saveMessage }}</div>
    <div *ngIf="data.discardMessage">{{ data.discardMessage }}</div>
    <div *ngIf="data.cancelMessage">{{ data.cancelMessage }}</div>
    <div *ngIf="data.showConflict" class="d-flex align-items-center conflictMessage">
      <mat-icon class="warning-icon">warning</mat-icon>
      <span>{{ data.conflictMessage }}</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="justify-content-end">
    <div class="row justify-content-end">
      <div class="col">
        <button mat-button [mat-dialog-close]="triOptionActionTypeEnum.Cancel">
          {{ data.cancelActionText }}
        </button>
      </div>

      <div class="row justify-content-end">
        <div class="col">
          <button
            mat-raised-button
            [mat-dialog-close]="triOptionActionTypeEnum.Discard"
            [disabled]="data.disableDiscardButton"
          >
            {{ data.confirmDiscardText }}
          </button>
        </div>
      </div>

      <div class="col">
        <button
          mat-raised-button
          [color]="data.confirmSaveButtonColor"
          [mat-dialog-close]="triOptionActionTypeEnum.Save"
          [disabled]="data.disableSaveButton"
        >
          {{ data.confirmSaveActionText }}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</article>
